module.exports = __webpack_public_path__ + "media/3_10.42a13249.wav";